"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarCircleController = void 0;
const module_abstract_1 = require("@kennethgomez/module/module.abstract");
const app_1 = require("@kennethgomez/app");
class StarCircleController extends module_abstract_1.Module {
    static CIRCLE_SIZE = 10;
    static CIRCLE_OFFSET = 25;
    splitStars(stars) {
        const splitIdx = Math.ceil(stars.length / 3);
        const circles = [];
        circles.push(stars.slice(0, splitIdx));
        circles.push(stars.slice(splitIdx, splitIdx * 2));
        circles.push(stars.slice(splitIdx * 2));
        return circles;
    }
    makeCircle(stars, x, y) {
        const n = stars.children.length;
        const increment = 360 / n;
        const startAngle = 0;
        let lastAnimation;
        for (let i = 0; i < n; i++) {
            const angle = startAngle + increment * i;
            const rads = (angle * Math.PI) / 180;
            const tx = x + StarCircleController.CIRCLE_SIZE * Math.cos(rads);
            const ty = y + StarCircleController.CIRCLE_SIZE * Math.sin(rads);
            const star = stars.children[i];
            star.scale.set(1);
            star.tint = 0xffffff;
            app_1.App.instance.canvas.animations.addAnimation(star, 'x', 50, {
                target: tx,
            });
            app_1.App.instance.canvas.animations.addAnimation(star, 'y', 50, {
                target: ty,
            });
            lastAnimation = app_1.App.instance.canvas.animations.addAnimation(star, 'alpha', 50, {
                target: 0.5,
            });
        }
        return lastAnimation;
    }
    moveCircle(circle, offsetX, offsetY) {
        return this.moveAbsoluteCircle(circle, circle.x + offsetX, circle.y + offsetY);
    }
    moveAbsoluteCircle(circle, x, y) {
        app_1.App.instance.canvas.animations.addAnimation(circle, 'alpha', 20, {
            target: 0.75,
        }).on('finish', () => {
            app_1.App.instance.canvas.animations.addAnimation(circle, 'alpha', 20, {
                target: 1,
            });
        });
        app_1.App.instance.canvas.animations.addAnimation(circle, 'x', 40, {
            target: x,
        });
        return app_1.App.instance.canvas.animations.addAnimation(circle, 'y', 40, {
            target: y,
        });
    }
    addAnimationToStars(stars, property, duration, values) {
        const n = stars.children.length;
        let lastAnimation;
        for (let i = 0; i < n; i++) {
            const star = stars.children[i];
            lastAnimation = app_1.App.instance.canvas.animations.addAnimation(star, property, duration, values);
        }
        return lastAnimation;
    }
}
exports.StarCircleController = StarCircleController;
